/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DispensersRouteRouteImport } from './routes/dispensers/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DispensersIndexRouteImport } from './routes/dispensers/index'
import { Route as DispensersNewRouteImport } from './routes/dispensers/new'
import { Route as DispensersDispenserIdRouteRouteImport } from './routes/dispensers/$dispenserId/route'
import { Route as DispensersDispenserIdIndexRouteImport } from './routes/dispensers/$dispenserId/index'
import { Route as DispensersDispenserIdTimelineRouteImport } from './routes/dispensers/$dispenserId/timeline'
import { Route as DispensersDispenserIdEditRouteImport } from './routes/dispensers/$dispenserId/edit'

const DispensersRouteRoute = DispensersRouteRouteImport.update({
  id: '/dispensers',
  path: '/dispensers',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DispensersIndexRoute = DispensersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DispensersRouteRoute,
} as any)
const DispensersNewRoute = DispensersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DispensersRouteRoute,
} as any)
const DispensersDispenserIdRouteRoute =
  DispensersDispenserIdRouteRouteImport.update({
    id: '/$dispenserId',
    path: '/$dispenserId',
    getParentRoute: () => DispensersRouteRoute,
  } as any)
const DispensersDispenserIdIndexRoute =
  DispensersDispenserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DispensersDispenserIdRouteRoute,
  } as any)
const DispensersDispenserIdTimelineRoute =
  DispensersDispenserIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => DispensersDispenserIdRouteRoute,
  } as any)
const DispensersDispenserIdEditRoute =
  DispensersDispenserIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => DispensersDispenserIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dispensers': typeof DispensersRouteRouteWithChildren
  '/dispensers/$dispenserId': typeof DispensersDispenserIdRouteRouteWithChildren
  '/dispensers/new': typeof DispensersNewRoute
  '/dispensers/': typeof DispensersIndexRoute
  '/dispensers/$dispenserId/edit': typeof DispensersDispenserIdEditRoute
  '/dispensers/$dispenserId/timeline': typeof DispensersDispenserIdTimelineRoute
  '/dispensers/$dispenserId/': typeof DispensersDispenserIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dispensers/new': typeof DispensersNewRoute
  '/dispensers': typeof DispensersIndexRoute
  '/dispensers/$dispenserId/edit': typeof DispensersDispenserIdEditRoute
  '/dispensers/$dispenserId/timeline': typeof DispensersDispenserIdTimelineRoute
  '/dispensers/$dispenserId': typeof DispensersDispenserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dispensers': typeof DispensersRouteRouteWithChildren
  '/dispensers/$dispenserId': typeof DispensersDispenserIdRouteRouteWithChildren
  '/dispensers/new': typeof DispensersNewRoute
  '/dispensers/': typeof DispensersIndexRoute
  '/dispensers/$dispenserId/edit': typeof DispensersDispenserIdEditRoute
  '/dispensers/$dispenserId/timeline': typeof DispensersDispenserIdTimelineRoute
  '/dispensers/$dispenserId/': typeof DispensersDispenserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dispensers'
    | '/dispensers/$dispenserId'
    | '/dispensers/new'
    | '/dispensers/'
    | '/dispensers/$dispenserId/edit'
    | '/dispensers/$dispenserId/timeline'
    | '/dispensers/$dispenserId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dispensers/new'
    | '/dispensers'
    | '/dispensers/$dispenserId/edit'
    | '/dispensers/$dispenserId/timeline'
    | '/dispensers/$dispenserId'
  id:
    | '__root__'
    | '/'
    | '/dispensers'
    | '/dispensers/$dispenserId'
    | '/dispensers/new'
    | '/dispensers/'
    | '/dispensers/$dispenserId/edit'
    | '/dispensers/$dispenserId/timeline'
    | '/dispensers/$dispenserId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DispensersRouteRoute: typeof DispensersRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dispensers': {
      id: '/dispensers'
      path: '/dispensers'
      fullPath: '/dispensers'
      preLoaderRoute: typeof DispensersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dispensers/': {
      id: '/dispensers/'
      path: '/'
      fullPath: '/dispensers/'
      preLoaderRoute: typeof DispensersIndexRouteImport
      parentRoute: typeof DispensersRouteRoute
    }
    '/dispensers/new': {
      id: '/dispensers/new'
      path: '/new'
      fullPath: '/dispensers/new'
      preLoaderRoute: typeof DispensersNewRouteImport
      parentRoute: typeof DispensersRouteRoute
    }
    '/dispensers/$dispenserId': {
      id: '/dispensers/$dispenserId'
      path: '/$dispenserId'
      fullPath: '/dispensers/$dispenserId'
      preLoaderRoute: typeof DispensersDispenserIdRouteRouteImport
      parentRoute: typeof DispensersRouteRoute
    }
    '/dispensers/$dispenserId/': {
      id: '/dispensers/$dispenserId/'
      path: '/'
      fullPath: '/dispensers/$dispenserId/'
      preLoaderRoute: typeof DispensersDispenserIdIndexRouteImport
      parentRoute: typeof DispensersDispenserIdRouteRoute
    }
    '/dispensers/$dispenserId/timeline': {
      id: '/dispensers/$dispenserId/timeline'
      path: '/timeline'
      fullPath: '/dispensers/$dispenserId/timeline'
      preLoaderRoute: typeof DispensersDispenserIdTimelineRouteImport
      parentRoute: typeof DispensersDispenserIdRouteRoute
    }
    '/dispensers/$dispenserId/edit': {
      id: '/dispensers/$dispenserId/edit'
      path: '/edit'
      fullPath: '/dispensers/$dispenserId/edit'
      preLoaderRoute: typeof DispensersDispenserIdEditRouteImport
      parentRoute: typeof DispensersDispenserIdRouteRoute
    }
  }
}

interface DispensersDispenserIdRouteRouteChildren {
  DispensersDispenserIdEditRoute: typeof DispensersDispenserIdEditRoute
  DispensersDispenserIdTimelineRoute: typeof DispensersDispenserIdTimelineRoute
  DispensersDispenserIdIndexRoute: typeof DispensersDispenserIdIndexRoute
}

const DispensersDispenserIdRouteRouteChildren: DispensersDispenserIdRouteRouteChildren =
  {
    DispensersDispenserIdEditRoute: DispensersDispenserIdEditRoute,
    DispensersDispenserIdTimelineRoute: DispensersDispenserIdTimelineRoute,
    DispensersDispenserIdIndexRoute: DispensersDispenserIdIndexRoute,
  }

const DispensersDispenserIdRouteRouteWithChildren =
  DispensersDispenserIdRouteRoute._addFileChildren(
    DispensersDispenserIdRouteRouteChildren,
  )

interface DispensersRouteRouteChildren {
  DispensersDispenserIdRouteRoute: typeof DispensersDispenserIdRouteRouteWithChildren
  DispensersNewRoute: typeof DispensersNewRoute
  DispensersIndexRoute: typeof DispensersIndexRoute
}

const DispensersRouteRouteChildren: DispensersRouteRouteChildren = {
  DispensersDispenserIdRouteRoute: DispensersDispenserIdRouteRouteWithChildren,
  DispensersNewRoute: DispensersNewRoute,
  DispensersIndexRoute: DispensersIndexRoute,
}

const DispensersRouteRouteWithChildren = DispensersRouteRoute._addFileChildren(
  DispensersRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DispensersRouteRoute: DispensersRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
